import React from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Paper, 
  Typography, 
  IconButton, 
  CircularProgress 
} from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import CloseIcon from '@mui/icons-material/Close';

const DesktopSearchSection = ({ 
  url,
  onUrlChange,
  videoTitle,
  onTitleClear,
  onAnalyzeClick,
  loading,
  error,
  drawerOpen,
  setDrawerOpen,
  t
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 0,
      width: '100%',
      maxWidth: '600px',
      mx: 'auto',
      alignItems: 'center',
    }}>
      {!videoTitle ? (
        <TextField
          fullWidth
          size="small"
          placeholder={t('analyze.urlPlaceholder')}
          value={url}
          onChange={onUrlChange}
          onClick={() => {
            if (drawerOpen) setDrawerOpen(false);
          }}
          error={!!error}
          helperText={error}
          inputProps={{
            inputMode: 'url',
            autoComplete: 'off'
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              bgcolor: '#fff',
              borderRadius: '20px 0 0 20px',
              height: '40px',
              border: '1px solid #ccc',
              boxShadow: 'none',
              pr: 0,
              '&:hover': { bgcolor: '#fff', borderColor: '#aaa' },
              '& fieldset': { border: 'none' },
              '&.Mui-focused fieldset': { border: 'none' }
            },
            '& .MuiOutlinedInput-input': { py: 1.5, px: 2, fontSize: 16 },
            '& .MuiFormHelperText-root': { ml: 0.5, fontSize: 12 }
          }}
        />
      ) : (
        <Paper
          elevation={0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            bgcolor: '#fff',
            borderRadius: '20px 0 0 20px',
            px: 2,
            height: '40px',
            width: 0,
            minWidth: 0,
            flexGrow: 1,
            border: '1px solid #ccc',
            borderRight: 'none',
            boxShadow: 'none',
            mr: 0,
            ml: 0,
            '&:hover': { bgcolor: '#f5f5f5' }
          }}
        >
          <YouTubeIcon 
            sx={{ 
              color: '#FF0000',
              mr: 1,
              fontSize: '1.5rem',
              flexShrink: 0
            }} 
          />
          <Typography
            variant="body1"
            sx={{
              flex: 1,
              color: '#333',
              fontWeight: 500,
              fontSize: 14,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '40px',
              minWidth: 0,
              maxWidth: '100%'
            }}
          >
            {videoTitle}
          </Typography>
          <IconButton
            size="small"
            onClick={onTitleClear}
            sx={{
              color: '#666',
              flexShrink: 0,
              '&:hover': {
                color: '#f44336',
                bgcolor: 'rgba(244, 67, 54, 0.08)'
              }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Paper>
      )}
      
      <Button
        variant="contained"
        onClick={onAnalyzeClick}
        disabled={loading || !url.trim()}
        sx={{
          minWidth: 80,
          height: '40px',
          borderRadius: '0 20px 20px 0',
          bgcolor: '#f2f2f2',
          color: '#222',
          fontWeight: 400,
          fontSize: 14,
          boxShadow: 'none',
          ml: '-1px',
          border: '1px solid #ccc',
          borderLeft: 'none',
          '&:hover': {
            bgcolor: '#e0e0e0',
            boxShadow: 'none',
          },
          '&.Mui-disabled': {
            bgcolor: '#f2f2f2',
            color: '#bbb',
          }
        }}
      >
        {loading ? (
          <CircularProgress size={20} sx={{ color: '#888' }} />
        ) : (
          t('analyze.analyzeButton')
        )}
      </Button>
    </Box>
  );
};

export default DesktopSearchSection; 